import { VariantGroupModelType } from '@teinor/erp/types/company/product/variant/variantGroup'
import { VariantGroupLangModelType } from '@teinor/erp/types/company/product/variant/variantGroup/variantGroupLang'
import { MediumModalCreateEdit, ModalCreateEditMediumLoading } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { useBasicData } from '../../../../../../../utils/hooks/useBasicData'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'


interface ModalCEVariantProps extends ModalEditComponentProps { }

interface ModifiedVariantModelType extends VariantGroupModelType {
    variantGroupLangs: string
}
const ModalCEVariant: React.FC<ModalCEVariantProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { basicData } = useBasicData({ url: '/api/app/product/productVariant/getVariantGroupInstance', params: { id: allRowData?.id }, doPetition: allRowData !== undefined })

    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: basicData?.VariantGroupLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const fields: FormRender<VariantGroupLangModelType & ModifiedVariantModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'ref_code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.ref_code
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: allRowData?.id
                },
                {
                    name: 'variantGroupLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
            ]
        }
    ]
    if (allRowData && userPermissions) {
        return (
            <ModalCreateEditMediumLoading fields={fields} url={'/api/app/product/productVariant/updateVariantGroup'} translations={{ title: t('editVariant', 'Editar variante') + ' - ' + allRowData?.['name'], button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} loading={data ? false : true} />
        )
    }
    return (
        <MediumModalCreateEdit fields={fields} url={'/api/app/product/productVariant/createVariantGroup'} translations={{
            title: t('createVariant', 'Crear variante'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}

export default ModalCEVariant